var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_vm._l((_vm.rangeList.slice(0,_vm.maxLines)),function(range){return _c('li',{key:range.from + '-' + range.to},[(range.description)?_c('strong',[_vm._v(_vm._s(range.description)),_c('br')]):_vm._e(),_vm._v(" "+_vm._s(_vm.getFormattedRange(range))+" ")])}),(_vm.rangeList.length > _vm.maxLines)?_c('li',[_vm._v(" ... ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }